import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import { Container, Typography } from "@mui/material";
import Footer from "../../Components/Footer";
import CallToEnroll from "../../Components/CallToEnroll";
import PageTitle from "../../Components/PageTitle";
import CounsellingBanner from "../../assets/Counselling.png";

const Counselling = () => {
  return (
    <>
      <Navbar />
      <PageTitle
        title="Student Counselling - Shree Mangalam School"
        description="At Shree Mangalam School, we provide dedicated academic and personal counselling to guide students through RIMC, Sainik School, and Military School preparation."
        url="/counselling"
        keywords="student counselling, career guidance, academic support, Shree Manglam counselling, RIMC guidance, military school preparation support"
      />

      <Header image={CounsellingBanner} alt={"Counselling Banner image"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Counseling and Student Support at Shree Mangalam School
          School
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we believe that the mental
          and emotional well-being of our students is just as important as their
          academic success. Our counseling services are designed to provide the
          support, guidance, and encouragement students need to navigate the
          challenges of school life, personal growth, and future aspirations.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Our dedicated team of trained counselors offers a safe and
          confidential space for students to express themselves, discuss any
          concerns, and receive expert guidance. Whether it’s dealing with
          stress, exam pressure, peer relationships, or career decisions, we are
          here to help every student feel supported, valued, and empowered.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We also conduct career counseling sessions, helping students explore
          various career paths and make informed decisions about their future.
          Through one-on-one discussions, group workshops, and personality
          assessments, we ensure that every student is guided toward a
          fulfilling and successful future.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we understand that each
          child is unique, and we are committed to providing personalized
          counseling to help them grow not only academically, but also
          emotionally and socially. Our aim is to foster resilient, confident,
          and well-balanced individuals who are equipped to face life's
          challenges with optimism and strength.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we don’t just teach — we
          inspire through every activity, every challenge, and every
          opportunity. Whether it’s on the sports field, in the classroom, or in
          the counseling room, we nurture courage, confidence, and character.
          Enroll now and let your child grow into a confident, capable, and
          compassionate individual — ready to take on the world.
        </Typography>
      </Container>
      <CallToEnroll />
      <Footer />
    </>
  );
};

export default Counselling;
